import React, { useEffect, useState } from 'react';
import Button from 'components/Form/Button';
import otherImage from '../../../../../../assets/assets/other-assets.png';
import ConfirmModal from 'components/Modal/ConfirmModal';
import withCreatePortal from 'components/HOC/withCreatePortal';
import { useRemovePhysicalTrustee } from 'common/queries-and-mutations/physical-asset';
import { toast } from 'react-toastify';
import { Alert } from 'components/Toast';

type Props = {
  assetId: number;
  assetName: string;
  trusteeName: string;
  trusteeId: number;
  onSuccess: () => void;
};

const EnhancedConfirmModal = withCreatePortal(ConfirmModal);

export default function TrusteePhysicalAssetCard({
  assetId,
  assetName,
  trusteeName,
  trusteeId,
  onSuccess
}: Props) {
  const [showAskToConfirm, setShowAskToConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState('');
  const [selectedAssetId, setSelectedAssetId] = useState<number | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { mutate, isSuccess, isError } = useRemovePhysicalTrustee();

  const handleDelete = () => {
    mutate({ assetId: selectedAssetId!, trusteeId });
  };

  useEffect(() => {
    if (isSuccess && !isError) {
      onSuccess();
      setShowAskToConfirm(false);
      setIsSubmitting(false);
      toast(<Alert message="Asset Successfully Removed" type="success" />);
    } else if (isError) {
      setIsSubmitting(false);
    }
  }, [isError, isSuccess]);

  return (
    <div>
      <div className="my-2 border border-[#E9EEFF] bg-[#F9F9F9] p-2 px-4">
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex items-center gap-5">
            <div className="mr-3 space-y-2">
              <img src={otherImage} className="h-[3rem] w-[3rem]" />
            </div>
            <div className="my-2 mr-3 space-y-2">
              <div className="font-circular text-xs font-medium text-[#7A7C87]">
                Asset
              </div>
              <div className="font-circular text-sm font-medium text-[#6A6A6A]">
                {assetName}
              </div>
            </div>
          </div>

          <div className="mr-3 flex flex-col space-y-6">
            <div className="flex flex-wrap items-center justify-end">
              <Button
                variant="outline"
                size="custom"
                className="w-[9rem] place-self-end rounded border-none p-3 text-center text-xs font-medium text-[#E30000]"
                label="Remove asset"
                onClick={() => {
                  setConfirmMessage(
                    `Confirm removal of Physical Asset - ${assetName} from Trustee ${trusteeName}?`
                  );
                  setSelectedAssetId(assetId);
                  setShowAskToConfirm(true);
                }}
              ></Button>
            </div>
          </div>
        </div>
      </div>
      {showAskToConfirm && (
        <EnhancedConfirmModal
          content={confirmMessage}
          onConfirm={() => {
            setIsSubmitting(true);
            handleDelete();
          }}
          onCancel={() => {
            setShowAskToConfirm(false);
          }}
          actionText="Confirm"
          cancelText="No"
          title="Action Required"
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
}
